import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone, ArrowUpRight } from 'lucide-react';

const Header = ({ onOpenContactForm }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname !== '/') { navigate('/'); setTimeout(() => { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); }, 100); }
    else { document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }); }
    setIsMobileMenuOpen(false);
  };

  return (
    <header data-testid="main-nav" className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white border-b-2 border-stone-200 shadow-sm' : 'bg-white border-b border-stone-200/50'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-[68px]">
          <button data-testid="header-logo" onClick={() => navigate('/')} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <img src="/logo-color.png" alt="Domain Trademark Name" className="h-10 w-auto" />
          </button>
          <nav className="hidden lg:flex items-center gap-10">
            {[{ label: 'Home', id: 'home' }, { label: 'Services', id: 'services' }, { label: 'Pricing', id: 'pricing' }, { label: 'Reviews', id: 'testimonials' }, { label: 'FAQ', id: 'faq' }].map((item) => (
              <button key={item.id} data-testid={`nav-${item.id}`} onClick={() => scrollToSection(item.id)}
                className="text-[13px] font-bold text-stone-900 hover:text-emerald-900 transition-colors uppercase tracking-wider">
                {item.label}
              </button>
            ))}
          </nav>
          <div className="hidden lg:flex items-center gap-5">
            <a href="tel:+18005551234" className="flex items-center text-[13px] font-medium text-stone-900 hover:text-emerald-900 transition-colors">
              <Phone className="w-3.5 h-3.5 mr-1.5" /> (800) 555-1234
            </a>
            <button data-testid="header-get-started" onClick={onOpenContactForm}
              className="group inline-flex items-center gap-2 px-5 py-2.5 bg-emerald-900 text-white text-[13px] font-bold tracking-wide border-2 border-emerald-900 hover:-translate-y-0.5 hover:shadow-[-4px_4px_0px_#EA580C] transition-all duration-200">
              Start Filing <ArrowUpRight className="w-3.5 h-3.5 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform duration-200" />
            </button>
          </div>
          <button data-testid="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden text-stone-900 p-2">
            {isMobileMenuOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
        {isMobileMenuOpen && (
          <div className="lg:hidden py-6 border-t-2 border-stone-200">
            <nav className="flex flex-col gap-4">
              {['Home', 'Services', 'Pricing', 'Reviews', 'FAQ'].map((label) => (
                <button key={label} onClick={() => scrollToSection(label.toLowerCase() === 'reviews' ? 'testimonials' : label.toLowerCase())} className="text-sm font-bold text-stone-600 hover:text-emerald-900 text-left uppercase tracking-wider">{label}</button>
              ))}
              <button onClick={onOpenContactForm} className="bg-emerald-900 text-white text-sm font-bold mt-2 w-full py-3 border-2 border-emerald-900 hover:shadow-[-4px_4px_0px_#EA580C] transition-all">Start Filing</button>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};
export default Header;
